<template>
    <v-container colum>
        <h2 class="subtitle">
            Options
        </h2>
        <v-row v-if="!loading">
            <v-col>
                <v-card>
                    <v-card-text>
                        <v-form ref="optionsForm">
                            <v-row>
                                <v-col cols=3>
                                    Default Shop
                                </v-col>
                                <v-col cols=9>
                                    <shop-select
                                    v-model="model.shopId"
                                    :rules="[rules.required]"
                                    ></shop-select>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols=3>
                                    Default Location
                                </v-col>
                                <v-col cols=9>
                                    <location-autocomplete
                                        v-model="model.locationId"
                                        :rules="[rules.required]"
                                    ></location-autocomplete>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols=3>
                                    Default Shipping Fees
                                </v-col>
                                <v-col cols=9>
                                    <shipping-select
                                        :locationId="model.locationId"
                                        v-model="model.shipping_id"
                                        :rules="[rules.required]"
                                    ></shipping-select>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols=3>
                                    Default Currency
                                </v-col>
                                <v-col cols=9>
                                    <currency-select
                                        :locationId="model.locationId"
                                        v-model="model.currencyId"
                                        :rules="[rules.required]"
                                    ></currency-select>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols=3>
                                    Default Tax Rate
                                </v-col>
                                <v-col cols=9>
                                    <tax-rate-autocomplete
                                        v-model="model.taxRateId"
                                        label="Tax Rate"
                                        :rules="[rules.required]"
                                        :locationId="model.locationId"
                                    ></tax-rate-autocomplete>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols=3>
                                    Standard Hour Product
                                </v-col>
                                <v-col cols=9>
                                    <product-autocomplete
                                        v-model="model.nonMemberProductId"
                                        :filters="{
                                            shopId: 3,
                                        }"
                                        :rules="[rules.notHeadOnlyRequired]"

                                            ></product-autocomplete>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols=3>
                                    Premium Hour Product
                                </v-col>
                                <v-col cols=9>
                                    <product-autocomplete
                                        v-model="model.productId"
                                        :filters="{
                                            shopId: 3,
                                        }"
                                        :rules="[rules.notHeadOnlyRequired]"

                                            ></product-autocomplete>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols=3>
                                    Standard Subscription Product
                                </v-col>
                                <v-col cols=9>
                                    <product-autocomplete
                                        v-model="model.standardSubProductId"
                                        :filters="{
                                            shopId: 3,
                                        }"
                                        :rules="[rules.notHeadOnlyRequired]"

                                            ></product-autocomplete>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols=3>
                                    Premium Subscription Product
                                </v-col>
                                <v-col cols=9>
                                    <product-autocomplete
                                        v-model="model.premiumSubProductId"
                                        :filters="{
                                            shopId: 3,
                                        }"
                                        :rules="[rules.notHeadOnlyRequired]"

                                            ></product-autocomplete>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols=3>
                                    Premium DUO Subscription Product
                                </v-col>
                                <v-col cols=9>
                                    <product-autocomplete
                                        v-model="model.duoSubProductId"
                                        :filters="{
                                            shopId: 3,
                                        }"
                                        :rules="[rules.notHeadOnlyRequired]"

                                            ></product-autocomplete>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols=3>
                                    Admin Code for Lock
                                </v-col>
                                <v-col cols=9>
                                    <v-text-field v-model="model.admin_code"></v-text-field>
                                </v-col>
                            </v-row>
                        </v-form>
                    </v-card-text>
                    <v-card-actions>
                        <v-btn text @click="cancel">Cancel</v-btn>
                        <v-spacer />
                        <v-btn color="primary" @click="save">Save</v-btn>
                    </v-card-actions>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import LocationAutocomplete from "@components/forms/autocomplete/Location.vue";
import TaxRateAutocomplete from "@components/forms/autocomplete/TaxRate.vue";
import ShippingSelect from "@components/forms/select/Shipping.vue";
import CurrencySelect from "@components/forms/select/Currency.vue";
import ProductAutocomplete from "@components/forms/autocomplete/Product.vue";
import ShopSelect from "@components/forms/select/Shop.vue";
import { mapActions } from 'vuex';
export default {
    components:{
        LocationAutocomplete,
        ShippingSelect,
        CurrencySelect,
        ProductAutocomplete,
        ShopSelect,
        TaxRateAutocomplete
    },

    data: () => ({
        model: {
            locationId:null,
        },
        loading:false
    }),
    computed: {
        rules: function() {
            return {
                required: value => !!value || "This field is mandatory.",
            };
        }
    },
    mounted(){
        this.loading=true
        this.getOptions().then((data) => {
            this.loading=false
            this.model=data?data:{}
        });
    },
    methods:{
        ...mapActions("xperience",["getOptions", "saveOptions"]),
        save(){
            if(this.$refs["optionsForm"].validate()){
                this.saveOptions(this.model).then((data) => {
                    this.model = data?data:{}
                })
            }
        },
        cancel(){
            this.$router.push("/simulator")
        }
    }

}
</script>

<style>

</style>